import { SectionProps } from '../types';
import { StyledWhispersSection } from './style';

export const WhispersSection: React.FC<SectionProps> = ({
  sectionName,
  textColor = '#000',
  image,
}) => {
  return (
    <StyledWhispersSection gap={'4px'} textColor={textColor}>
      {image && <img src={image} alt={sectionName + `prefix image`} />}
      <span className={'section-default__section-name'}>{sectionName}</span>
      {image && <img src={image} alt={sectionName + `prefix image`} />}
    </StyledWhispersSection>
  );
};
